(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/typeof', 'babel-runtime/core-js/number/is-safe-integer'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/typeof'), require('babel-runtime/core-js/number/is-safe-integer'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._typeof, global.isSafeInteger);
    global.lang = mod.exports;
  }
})(this, function (exports, _typeof2, _isSafeInteger) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.toString = exports.length = exports.isSymbol = exports.isString = exports.isObject = exports.isNil = exports.isNaturalInteger = exports.isFunction = undefined;

  var _typeof3 = _interopRequireDefault(_typeof2);

  var _isSafeInteger2 = _interopRequireDefault(_isSafeInteger);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * Tests whether <code>arg</code> is a function.
   * @function
   * @param {*} arg The value to test
   * @return {boolean} True if <code>arg</code> is a function, false otherwise
   * @memberof util
   * @private
   * @since 1.0.0
   */


  var isFunction = function isFunction(arg) {
    return typeof arg === 'function';
  };
  /**
   * Tests whether <code>arg</code> is a natural integer.
   * @function
   * @param {*} arg The value to test
   * @return {boolean} True if <code>arg</code> is a natural integer, false otherwise
   * @memberof util
   * @private
   * @since 1.0.0
   */


  var isNaturalInteger = function isNaturalInteger(arg) {
    return (0, _isSafeInteger2.default)(arg) && arg >= 0;
  };
  /**
   * Tests whether <code>arg</code> is a <code>undefined</code> or <code>null</code>.
   * @function
   * @param {*} arg The value to test
   * @return {boolean} True if <code>arg</code> is <code>undefined</code> or <code>null</code>, false otherwise
   * @memberof util
   * @private
   * @since 1.0.0
   */


  var isNil = function isNil(arg) {
    return arg === undefined || arg === null;
  };
  /**
   * Tests whether <code>arg</code> is a string.
   * @function
   * @param {*} arg The value to test
   * @return {boolean} True if <code>arg</code> is a string, false otherwise
   * @memberof util
   * @private
   * @since 1.0.0
   */


  var isString = function isString(arg) {
    return typeof arg === 'string';
  };
  /**
   * Tests whether <code>arg</code> is a Symbol.
   * @param {*} arg The value to test
   * @return {boolean} True if <code>arg</code> is a Symbol, false otherwise
   * @memberof util
   * @private
   * @since 1.0.0
   * @see {@link https://mdn.io/Symbol|Symbol} for more information.
   */


  var isSymbol = function isSymbol(arg) {
    return (typeof arg === 'undefined' ? 'undefined' : (0, _typeof3.default)(arg)) === 'symbol';
  };
  /**
   * Returns the length of <code>arg</code>.
   * @function
   * @memberof util
   * @param {*} arg The value of which length must be returned
   * @returns {number} The length of <code>arg</code>
   * @private
   * @since 1.0.0
   */


  var length = function length(arg) {
    if (isNil(arg) || !isNaturalInteger(arg.length)) return 0;
    return arg.length;
  };
  /**
   * Converts <code>arg</code> to a string using string interpolation.
   * @param {*} arg The value to convert
   * @return {string} The string representation of <code>arg</code>
   * @memberof util
   * @private
   * @since 1.0.0
   */


  var toString = function toString(arg) {
    return typeof arg === 'string' ? arg : '' + arg;
  };
  /**
   * Tests whether <code>arg</code> is a object.
   * @param {*} arg The value to test
   * @return {boolean} True if <code>arg</code> is an <code>Object</code>, false otherwise
   * @memberof util
   * @private
   * @since 1.0.0
   */


  var isObject = function isObject(arg) {
    return arg instanceof Object;
  };

  exports.isFunction = isFunction;
  exports.isNaturalInteger = isNaturalInteger;
  exports.isNil = isNil;
  exports.isObject = isObject;
  exports.isString = isString;
  exports.isSymbol = isSymbol;
  exports.length = length;
  exports.toString = toString;
});